import { createAction } from 'redux-actions';

import callApi from '../../../util/apiCaller';

export const fetchPlansCb = createAction('FETCH_PLANS_CB');

export function fetchPlans(period) {
  return dispatch => {
    return callApi(dispatch, `public/pricing/plans/${period}`, null).then(res => {
      const plans = res.plans || res;
      dispatch(fetchPlansCb({ plans, period }));
      return { plans, period };
    });
  };
}
